export default __webpack_public_path__ + "static/media/delta.9bf8af4b.svg";